import ReactGA from 'react-ga4';

const TRACKING_ID = "G-DJ9XR93LJT";
ReactGA.initialize(TRACKING_ID);

export default ReactGA;
